import {Pipe, PipeTransform} from '@angular/core';
import {IEntryByDate} from '../_interface/entries-types.type';

@Pipe({name: 'dateRange'})
export class DateRangePipe implements PipeTransform {
	transform(entryDate: IEntryByDate): string {
		return (entryDate.range.from.isSame(entryDate.range.to, 'month')) ?
			`${entryDate.range.from.format('D')} -  ${entryDate.range.to.format('D MMMM YYYY')}` :
			`${entryDate.range.from.format('D MMMM')} -  ${entryDate.range.to.format('D MMMM YYYY')}`;
	}
}
